const cart = {
    state: {
      carts:[],
      active: 0,
      stripe:null,
      studentCodesId:[],
    },
    mutations: {
      initialize(state){
        state.active = 0  
      },
      addActive(state){
        if(state.active<2)
        state.active ++
      },
      setActive(state,active){
        state.active = active
      },
      setStripe(state,stripe){
        state.stripe = stripe
      },
      getCarts(state,carts){
        state.carts = carts
      },
      setStudentCodesId(state,ids){
        state.studentCodesId = ids
      },
    },
    actions: {
      getCarts(context,carts
        ){
        context.commit('getCarts',carts)
       },
      setActive(context,active
        ){
        context.commit('setActive',active)
       },
       setStripe(context,stripe
        ){
        context.commit('setStripe',stripe)
       },
      addActive(context){
        context.commit('addActive')
       },
       initialize(context){
        context.commit('initialize')
       },
       setStudentCodesId(context,ids){
        context.commit('setStudentCodesId', ids)
        }
    }
}

export default cart